import { useEffect, useState } from "react";
import "./ActivitiesPersonalApplicationOverview.scss";
import { nullUndefinedEmptyCheck } from "../../../../../../Services/Helpers/Helper";
import profile_default from "../../../../../../../Assets/profile/profile_default.svg";
import { SERVICES_STATUS, TOAST_ERRORS, TOASTER_CONFIGS } from "../../../../../../Utilities/Constants/Constants";
import { toast } from "react-toastify";

const ActivitiesPersonalApplicationOverview = (overviewProps: any) => {
  const [tutorDetails, setTutorDetails] = useState<any>({});
  const [comments, setComments] = useState<any>("");
  const [commentsTouched, setCommentsTouched] = useState<any>(false);

  useEffect(() => {
    setTutorDetails(overviewProps.tutorDetail);
    setComments(
      nullUndefinedEmptyCheck(overviewProps.tutorDetail.basic_review_comment)
        ? overviewProps.tutorDetail.basic_review_comment
        : ""
    );
  }, [overviewProps.tutorDetail]);

  return (
    <>
      <div className="application_overview_wrapper">
        <div className="row tutor_info_label_wrapper">
          <div className="col-md-12 profile_image_wrapper">
            <img
              className="profile_image"
              src={
                nullUndefinedEmptyCheck(tutorDetails.profile_details?.image)
                  ? tutorDetails.profile_details?.image
                  : profile_default
              }
              alt="Learn and Play"
            />
          </div>
        </div>
        <div className="row tutor_info_label_wrapper">
          <div className="col-md-6">
            <div className="row">
              <div className="col-md-6 tutor_info_label">First Name</div>
              <div className="col-md-6 tutor_info">
                {tutorDetails.profile_details?.firstname}
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="row">
              <div className="col-md-6 tutor_info_label">Last Name</div>
              <div className="col-md-6 tutor_info">
                {tutorDetails?.profile_details?.lastname}
              </div>
            </div>
          </div>
        </div>
        <div className="row tutor_info_label_wrapper">
          <div className="col-md-6">
            <div className="row">
              <div className="col-md-6 tutor_info_label">Email</div>
              <div className="col-md-6 tutor_info">
                {tutorDetails?.profile_details?.email}
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="row">
              <div className="col-md-6 tutor_info_label">Phone</div>
              <div className="col-md-6 tutor_info">
                {tutorDetails?.profile_details?.phone_number}
              </div>
            </div>
          </div>
        </div>
        {/*  <div className="row tutor_info_label_wrapper">
         <div className="col-md-6">
            <div className="row">
              <div className="col-md-6 tutor_info_label">Experience</div>
              <div className="col-md-6 tutor_info">
                {tutorDetails?.experience}
              </div>
            </div>
          </div> 
           <div className="col-md-6">
            <div className="row">
              <div className="col-md-6 tutor_info_label">Rating</div>
              <div className="col-md-6 tutor_info">{tutorDetails?.rating}</div>
            </div>
          </div>
        </div> */}
        <div className="row tutor_info_label_wrapper">
        <div className="col-md-6">
            <div className="row">
              <div className="col-md-6 tutor_info_label">
                Gender of camp Manager
              </div>
              <div className="col-md-6 tutor_info">{tutorDetails?.gender}</div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="row">
              <div className="col-md-6 tutor_info_label">Address</div>
              <div className="col-md-6 tutor_info">{tutorDetails?.address}</div>
            </div>
          </div>
          
        </div>
        <div className="row tutor_info_label_wrapper">
          <div className="col-md-6">
            <div className="row">
              <div className="col-md-6 tutor_info_label">City</div>
              <div className="col-md-6 tutor_info">{tutorDetails?.city}</div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="row">
              <div className="col-md-6 tutor_info_label">State</div>
              <div className="col-md-6 tutor_info">{tutorDetails?.state}</div>
            </div>
          </div>
        </div>
        <div className="row tutor_info_label_wrapper">
          <div className="col-md-6">
            <div className="row">
              <div className="col-md-6 tutor_info_label">Country</div>
              <div className="col-md-6 tutor_info">{tutorDetails?.country}</div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="row">
              <div className="col-md-6 tutor_info_label">Pincode</div>
              <div className="col-md-6 tutor_info">{tutorDetails?.pincode}</div>
            </div>
          </div>
        </div>
        <div className="row tutor_info_label_wrapper">
          <div className="col-md-6">
            <div className="row">
              <div className="col-md-6 tutor_info_label">Highest Qualification</div>
              <div className="col-md-6 tutor_info">{tutorDetails?.high_education}</div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="row">
              <div className="col-md-6 tutor_info_label">Degree</div>
              <div className="col-md-6 tutor_info">{tutorDetails?.degree ? tutorDetails?.degree : "N/A"}</div>
            </div>
          </div>
        </div>
        <div className="row tutor_info_label_wrapper">
          <div className="col-md-6">
            <div className="row">
              <div className="col-md-6 tutor_info_label">Degree Specification</div>
              <div className="col-md-6 tutor_info">{tutorDetails?.degree_subject}</div>
            </div>
          </div>
          </div>
       {/*  <div className="row tutor_info_label_wrapper">
          <div className="col-md-12">
            <div className="chip_label_wrapper">
              <div className="fields_label_address">Equipments</div>
              <div className="field_values_chips mt-3">
                {tutorDetails?.equipments?.map(
                  (amenitiesElement: any, index: any) => {
                    return (
                      <>
                        <div key={index} className="amenities_chips">
                          {amenitiesElement}
                        </div>
                      </>
                    );
                  }
                )}
              </div>
            </div>
          </div>
        </div> */}
        {/* <div className="row tutor_info_label_wrapper">
          <div className="col-md-12">
            <div className="chip_label_wrapper">
              <div className="fields_label_address">Activities Offered</div>
              <div className="field_values_chips mt-3">
                {tutorDetails?.activities_offered?.map(
                  (amenitiesElement: any, index: any) => {
                    return (
                      <>
                        <div key={index} className="amenities_chips">
                          {amenitiesElement}
                        </div>
                      </>
                    );
                  }
                )}
              </div>
            </div>
          </div>
        </div> */}
        <div className="row tutor_info_label_wrapper">
          <div className="col-md-12">
            <div className="chip_label_wrapper">
              <div className="fields_label_address">Specialization</div>
              <div className="field_values_chips mt-3">
                {tutorDetails?.specializations?.map(
                  (amenitiesElement: any, index: any) => {
                    return (
                      <>
                        <div key={index} className="amenities_chips">
                          {amenitiesElement}
                        </div>
                      </>
                    );
                  }
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="row tutor_info_label_wrapper">
          <div className="col-md-12">
            <div className="tutor_info_label">Comments</div>
            <textarea
              value={comments}
              onChange={(event: any) => {
                setComments(event.target.value);
              }}
              onBlur={() => {
                setCommentsTouched(true);
              }}
              placeholder="Please enter your comments"
              disabled={
                tutorDetails.status !== SERVICES_STATUS.PENDING.toLowerCase()
              }
            ></textarea>
            {(comments?.length === 0 || comments == null) &&
              commentsTouched && (
                <div className="error_message">
                  Please enter some comments about the Tutor's personal and
                  professional details
                </div>
              )}
          </div>
        </div>
        <button
          className="next_button"
          onClick={() => {
            if(tutorDetails.status === SERVICES_STATUS.PENDING.toLowerCase()){
            /* comments?.length === 0 || comments == null
              ? setCommentsTouched(true)
              : */ overviewProps.updateTutorverification({
                  basic_review: true,
                  basic_review_comment: comments,
                });
                (!overviewProps.permission) ? toast.error(TOAST_ERRORS.PERMISION_DENIED , TOASTER_CONFIGS) 
                : overviewProps.handleNext();

              }else{
                overviewProps.handleNext();
              }
          }}
        >
          {/* {tutorDetails.status === SERVICES_STATUS.PENDING.toLowerCase()
            ? "Update & Go to Documents"
            : "Go to Documents"} */}
            Next
        </button>
      </div>
    </>
  );
};
export default ActivitiesPersonalApplicationOverview;
